import React, { createContext, useContext, useState } from 'react';

const GroupOrderContext = createContext();

export const useGroupOrder = () => useContext(GroupOrderContext);

export const GroupOrderProvider = ({ children }) => {
    const [groupOrder, setGroupOrder] = useState(1); // Default value or null

    return (
        <GroupOrderContext.Provider value={{ groupOrder, setGroupOrder }}>
            {children}
        </GroupOrderContext.Provider>
    );
};